import {
  EMPTY_VALUE,
  distinctMatchedOn,
  matchedOnLabelKey,
} from '@/helpers/orgSearch'
import { Badge, HStack, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

type Props = {
  matchedOn: string[]
  matchedEmails: string[]
}

export function MatchedOnBadges({ matchedOn, matchedEmails }: Readonly<Props>) {
  const { t } = useTranslation('features', { useSuspense: false })

  if (matchedOn.length === 0 && matchedEmails.length === 0) {
    return <Text>{EMPTY_VALUE}</Text>
  }

  return (
    <VStack align="start" gap={1}>
      <HStack gap={1} flexWrap="wrap">
        {distinctMatchedOn(matchedOn).map((value) => {
          const labelKey = matchedOnLabelKey(value)
          if (!labelKey) {
            return (
              <Badge key={value} size="sm" variant="subtle" colorPalette="gray">
                {value}
              </Badge>
            )
          }
          return (
            <Badge key={value} size="sm" variant="subtle" colorPalette="blue">
              {t(`accountManagement.${labelKey}`)}
            </Badge>
          )
        })}
      </HStack>
      {matchedEmails.length > 0 ? (
        <VStack align="start" gap={0}>
          {[...new Set(matchedEmails)].map((email) => (
            <Text key={email} fontSize="xs" color="fg.muted">
              {email}
            </Text>
          ))}
        </VStack>
      ) : null}
    </VStack>
  )
}
